if (!customElements.get('pdf-signup')) {
  customElements.define('pdf-signup', class PdfSignup extends HTMLElement {
    constructor() {
      super();

      this.toggleLink = this.querySelector('.pdf-signup__toggle-link');
      this.formWrapper = this.querySelector('.pdf-signup__form-wrapper');
      this.successWrapper = this.querySelector('.pdf-signup__success-wrapper');

      // New DOM selections for the form, tags, and phone inputs
      this.form = this.querySelector('form');
      this.tagsInput = this.querySelector('input[name="contact[tags]"]');
      this.phoneInput = this.querySelector('input[name="contact[phone]"]');

      if (this.tagsInput) {
        this.baseTags = this.tagsInput.value;
      }

      if (this.toggleLink) {
        this.toggleLink.addEventListener('click', this.handleToggleClick.bind(this));
      }

      if (this.form && this.tagsInput && this.phoneInput) {
        this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
      }

      if (this.successWrapper && window.location.search.includes('customer_posted=true')) {
        setTimeout(() => {
          this.cleanUrl();
        }, 100);
      }
    }

    handleToggleClick() {
      if (this.formWrapper) {
        this.formWrapper.classList.remove('hidden');
        this.toggleLink.classList.add('hidden');
      }
    }

    handleFormSubmit(event) {
      const phoneVal = this.phoneInput.value.trim();

      if (phoneVal) {
        const phoneTag = `Spec sheet phone: ${phoneVal}`;

        this.tagsInput.value = this.baseTags ? `${this.baseTags}, ${phoneTag}` : phoneTag;
      }
    }

    cleanUrl() {
      if (window.history && window.history.replaceState) {
        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('customer_posted');
        cleanUrl.searchParams.delete('form_type');
        cleanUrl.hash = '';
        window.history.replaceState({}, document.title, cleanUrl.toString());
      }
    }
  });
}